import { render, staticRenderFns } from "./LogbookRow.vue?vue&type=template&id=5412b514&scoped=true&"
import script from "./LogbookRow.vue?vue&type=script&lang=js&"
export * from "./LogbookRow.vue?vue&type=script&lang=js&"
import style0 from "./LogbookRow.vue?vue&type=style&index=0&id=5412b514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412b514",
  null
  
)

export default component.exports